import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import { articles } from '../data/articles';

const Journal = () => (
  <div className="page">
    <PageHero kicker="Journal" title="Notes from the chair.">
      Practical guides on color, bridal hair, and the work behind the chair, from
      the stylists at The Loft.
    </PageHero>

    <section className="section">
      <div className="container">
        {articles.length === 0 ? (
          <p className="lede" style={{ marginInline: 'auto', textAlign: 'center' }}>
            New stories are on the way. Check back soon.
          </p>
        ) : (
          <div className="journal-grid">
            {articles.map((a) => (
              <Link to={`/journal/${a.slug}`} className="journal-card reveal" key={a.slug}>
                <span className="journal-card__cat">{a.category}</span>
                <h2>{a.title}</h2>
                <p>{a.excerpt}</p>
                <span className="journal-card__more">
                  Read more <span className="arrow">→</span>
                  <span className="journal-card__time">{a.readMins} min read</span>
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  </div>
);

export default Journal;
